/*
 * @Author: your name
 * @Date: 2022-03-01 11:06:49
 * @LastEditTime: 2022-05-04 21:57:49
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\store\modules\app.js
 */
import storage from '@/utils/storage-service'
export default {
    state: {
        winHeight: 0,
        winWidth: 0,
        navbar: {
            title: "数字化全域经销商体系",
            isShow: true,
            isBack: false
        },
        tabbar: {
          isShow: true,
          active: 1
        },
        system: {
            openInWechat: false,
            openInIOS: false,
        }
    },
    mutations: {
        // 设置导航栏
        SET_NAVBAR(state, payload) {
            if(payload) {
            state.navbar.isShow = payload.isShow
            state.navbar.title = payload.title
            state.navbar.isBack = payload.isBack
            }
        },

        // 设置底部菜单
        SET_TABBAR(state, payload) {
            console.log(payload)
            if(payload) {
                state.tabbar.isShow = payload.isShow
                state.tabbar.active = payload.active
            }
        },
        SET_SYSTEM_SETTING(state, payload) {
            if(payload) {
                state.system.openInWechat = payload.openInWechat
                state.system.openInIOS = payload.openInIOS
            }
        },
        SET_WINDOW_SIZE(state, payload) {
            if(payload) {
                state.winHeight = payload.height
            }
        }
    },
    actions: {
        /** 设置导航栏 */
        SetNavbar(context, payLoad) {
            context.commit('SET_NAVBAR', payLoad)
        },

        /** 设置底部菜单 */
        SetTabbar(context, payLoad) {
            context.commit('SET_TABBAR', payLoad)
        },

        /**
         * 清除本地全部缓存
         */
        Clear() {
            storage.clear()
        },
        
        /**
         * 更新系统配置
         */
        SetSystemSetting(context, payload) {
            context.commit('SET_SYSTEM_SETTING', payload)
        },
        /**
         * 初始化屏幕高度
         */
        SetWindowSize(context, payload) {
            context.commit('SET_WINDOW_SIZE', payload)
        },
    },
    getters: {

    }
};  